import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BsInbox } from 'react-icons/bs';
import {
  Card,
  Button,
  Modal,
  Row,
  Col,
  Form,
  Container,
} from 'react-bootstrap';
import { Field, Formik } from 'formik';
import { FaSearch } from 'react-icons/fa';
import _ from 'lodash';
import DateMask from '~/Components/DateMask';
import MaskedInput from 'react-text-mask';
import * as api from '~/Services/Service';
import { format } from '~/Utils/Helpers';
import * as constants from '~/constant';

import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import Aviso from '~/Components/Aviso';
import ConfirmButton from '~/Components/ConfirmButton';
import AuthStorage from '~/Utils/AuthStorage';

import { CondicoesEspeciaisStatus } from '~/constant';
const AutorizacaoVenda = ({ history }) => {
  const [buscandoPropostas, setBuscandoPropostas] = useState(false);
  const [busy, setBusy] = useState(false);
  const [propostasAuxiliares, setPropostasAuxiliares] = useState([]);
  const [propostaSendoVisualizada, setPropostaSendoVisualizada] = useState(
    null
  );

  useEffect(() => {
    buscarPropostasRapidasAuxiliares();
  }, []);

  const buscarPropostasRapidasAuxiliares = React.useCallback(async () => {
    setBuscandoPropostas(true);
    try {
      const propostas = await api.buscarPropostasGravadas({
        codigo_proposta: '',
        tipo_proposta: '0',
        data_inicial: '',
        data_final: '',
      });

      setPropostasAuxiliares(propostas);
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Erro ao buscar propostas gravadas');
    } finally {
      setBuscandoPropostas(false);
    }
  }, []);

  const filtrarPropostasRapidasAuxiliares = async filtro => {
    try {
      setBuscandoPropostas(true);
      const filtroLimpo = Object.fromEntries(
        Object.entries(filtro).filter(
          ([_, value]) => value !== '' && value !== null && value !== undefined
        )
      );
      const propostas = await api.buscarPropostasGravadas(filtroLimpo);
      setPropostasAuxiliares(propostas);
    } catch (error) {
      toast.error(error.message || 'Erro ao buscar propostas.');
    } finally {
      setBuscandoPropostas(false);
    }
  };

  const excluirProposta = async codigoProposta => {
    setPropostasAuxiliares(
      propostasAuxiliares.map(proposta => {
        if (proposta.codigo === codigoProposta)
          proposta.excluindo = !proposta.excluindo;
        return proposta;
      })
    );
    setBusy(true);

    try {
      await api.excluirPropostaRapidaAuxiliar(codigoProposta);
      toast.success(`Proposta #"${codigoProposta} excluída com sucesso`);
      const pras = propostasAuxiliares.filter(
        proposta => proposta.codigo !== codigoProposta
      );
      setPropostasAuxiliares(pras);
    } catch (err) {
      console.error(err);
      toast.error(
        err.message || 'Erro ao excluir a proposta #' + codigoProposta
      );
      setPropostasAuxiliares(
        propostasAuxiliares.map(proposta => {
          if (proposta.codigo === codigoProposta)
            proposta.excluindo = !proposta.excluindo;
          return proposta;
        })
      );
    } finally {
      setBusy(false);
    }
  };

  const redirecionarParaVenda = (proposta, condicaoEspecial) => {
    if (condicaoEspecial) {
      history.push('/vendas/contraproposta?codigoProposta=' + proposta.codigo);
    } else {
      history.push('/vendas?codigoProposta=' + proposta.codigo);
    }
  };

  const renderListaPropostasRapidasAuxiliares = () => {
    const propostasAgrupadas = _(propostasAuxiliares)
      .orderBy(p => p.sequencia)
      .groupBy(p => p.codigo)
      .map(values => ({
        proposta: values[0], // primeira proposta
        propostas: values,
      }))
      .value();
    return propostasAgrupadas.map(({ proposta, propostas }, index) => {
      
      const isPropostaRestritaDiretoria = proposta.status_condicao_especial == CondicoesEspeciaisStatus.PendenteDiretoria && !AuthStorage.temCaracteristica(552);
      return (
        <Container>
          <Card key={proposta.codigo} className="mb-2">
            <Card.Body>
              <div className="d-flex flex-column flex-sm-row justify-content-between">
                <h4>#{proposta.codigo}</h4>
                <small>
                  {`Realizada por ${
                    proposta.proposta.usuario_digitacao.nome
                  } em ${format.date(proposta.data)}`}
                </small>
              </div>
              <p>{proposta && proposta.familia && proposta.familia.nome}</p>

              {propostas.map(p => (
                <p key={p.imovel.codigo}>
                  <span className="text-muted mr-1">#{p.imovel.codigo}</span>
                  Quadra: {p.imovel.quadra} / Lote: {p.imovel.lote}
                </p>
              ))}

              <div className="d-flex flex-column flex-sm-row justify-content-end w-100 button-area">
                <Button
                  variant="outline-primary"
                  onClick={() =>
                    setPropostaSendoVisualizada({ proposta, propostas })
                  }
                  disabled={busy}
                >
                  Ver justificativa
                </Button>

                { !isPropostaRestritaDiretoria && (
                  <>
                    <ConfirmButton
                      variant="outline-danger"
                      confirmTitle="Confirmação"
                      confirmText="Deseja excluir esta proposta?"
                      onConfirm={() => excluirProposta(proposta.codigo)}
                      disabled={busy}
                    >
                      {proposta.excluindo ? 'Aguarde...' : 'Excluir'}
                    </ConfirmButton>
                  </>
                )}
                <Button
                  variant="primary"
                  disabled={busy}
                  onClick={() =>
                    redirecionarParaVenda(proposta, AuthStorage.isCorretor())
                  }
                >
                  {isPropostaRestritaDiretoria ? "Visualizar" : "Revisar e Aprovar"}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Container>
      );
    });
  };

  const renderModalPropostaSendoVisualizada = () => {
    if (propostaSendoVisualizada == null) return null;

    return (
      <>
        <Modal.Header closeButton>
          Proposta #{propostaSendoVisualizada.proposta.codigo}
        </Modal.Header>
        <Modal.Body>
          <p
            style={{
              whiteSpace: 'pre-wrap',
            }}
          >
            {propostaSendoVisualizada.proposta.justificativa}
          </p>
        </Modal.Body>
      </>
    );
  };

  return (
    <>
      <Header title="Autorização de Propostas"></Header>
      {!AuthStorage.isCorretor() && (
        <div className="mt-2">
          <Formik
            initialValues={{
              codigo_proposta: '',
              tipo_proposta: '0',
              data_inicial: '',
              data_final: '',
            }}
            onSubmit={filtro => {
              filtrarPropostasRapidasAuxiliares(filtro);
            }}
          >
            {({ handleSubmit, setFieldValue, errors, touched, values }) => (
              <Form
                onSubmit={handleSubmit}
                className="container-fluid bg-white p-3 justify-content-center d-flex"
              >
                <Row>
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Group controlId="codigo_proposta">
                      <Form.Label>Proposta</Form.Label>
                      <Field
                        type="text"
                        name="codigo_proposta"
                        className="form-control"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={2} lg={3}>
                    <Form.Group controlId="tipo_proposta">
                      <Form.Label>Tipo</Form.Label>
                      <Field
                        as="select"
                        name="tipo_proposta"
                        className="form-control"
                      >
                        <option value="0">Todos</option>
                        <option value="1">Venda Gravada</option>
                        <option value="2">Venda com Condição Especial</option>
                        <option value="3">Contraproposta</option>
                      </Field>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <DateMask
                      initialValue={values.data_inicial}
                      onValidate={value => setFieldValue('data_inicial', value)}
                      restrictToSqlMinDate
                      allowPast
                    >
                      {({ dateError, dateValue, setDate }) => (
                        <Form.Group controlId="values.data_inicial">
                          <Form.Label>Data inicial</Form.Label>
                          <MaskedInput
                            name="data_inicial"
                            type="tel"
                            guide={false}
                            className={`form-control ${((errors.data_inicial &&
                              touched.data_inicial) ||
                              dateError) &&
                              'is-invalid'}`}
                            placeholder="Ex.: 01/01/2019"
                            mask={constants.MASK_DATE}
                            value={dateValue}
                            onChange={e => setDate(e.target.value)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.data_inicial}
                          </Form.Control.Feedback>
                          <Form.Control.Feedback type="invalid">
                            {dateError}
                          </Form.Control.Feedback>
                        </Form.Group>
                      )}
                    </DateMask>
                  </Col>
                  <Col xs={12} sm={6} md={3} lg={2}>
                    <DateMask
                      initialValue={values.data_final}
                      onValidate={value => setFieldValue('data_final', value)}
                      restrictToSqlMinDate
                      allowPast
                    >
                      {({ dateError, dateValue, setDate }) => (
                        <Form.Group controlId="values.data_final">
                          <Form.Label>Data final</Form.Label>
                          <MaskedInput
                            name="data_final"
                            type="tel"
                            guide={false}
                            className={`form-control ${((errors.data_final &&
                              touched.data_final) ||
                              dateError) &&
                              'is-invalid'}`}
                            placeholder="Ex.: 01/01/2019"
                            mask={constants.MASK_DATE}
                            value={dateValue}
                            onChange={e => setDate(e.target.value)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.data_final}
                          </Form.Control.Feedback>
                          <Form.Control.Feedback type="invalid">
                            {dateError}
                          </Form.Control.Feedback>
                        </Form.Group>
                      )}
                    </DateMask>
                  </Col>
                  <Col className="d-flex align-items-center mt-3">
                    <Button variant="primary" type="submit" className="">
                      <FaSearch />
                      <span className="d-xs-none"> Buscar</span>
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
      )}
      <div className="mt-2">
        {buscandoPropostas && (
          <Loading label="Carregando propostas gravadas..." />
        )}
        {!buscandoPropostas && propostasAuxiliares.length === 0 && (
          <Aviso
            icon={<BsInbox fontSize={72} />}
            text="Nenhuma proposta encontrada"
          />
        )}
        {!buscandoPropostas &&
          propostasAuxiliares.length > 0 &&
          renderListaPropostasRapidasAuxiliares()}
      </div>
      <Modal
        show={propostaSendoVisualizada != null}
        onHide={() => setPropostaSendoVisualizada(null)}
      >
        {renderModalPropostaSendoVisualizada()}
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setPropostaSendoVisualizada(null)}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withRouter(AutorizacaoVenda);
